import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "sitemap-robots-explorer",
  title: "Sitemap Robots Explorer",
  description:
    "Explore robots.txt, discover sitemap files, scan URLs, and categorize site structure from one input.",
  category: "SEO",
} satisfies ToolMeta;
